import { render, staticRenderFns } from "./AddonProductSkeleton.vue?vue&type=template&id=f027b032&scoped=true&"
var script = {}
import style0 from "./AddonProductSkeleton.vue?vue&type=style&index=0&id=f027b032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f027b032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f027b032')) {
      api.createRecord('f027b032', component.options)
    } else {
      api.reload('f027b032', component.options)
    }
    module.hot.accept("./AddonProductSkeleton.vue?vue&type=template&id=f027b032&scoped=true&", function () {
      api.rerender('f027b032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/Skeletons/AddonProductSkeleton.vue"
export default component.exports